import { citySchema } from "@redotech/redo-platform-common/geographic-unit";
import * as z from "zod";

export const getCities = {
  name: "getCities" as const,
  description:
    "Cities within one country and state, for a city or proximity condition.",
  mutates: false,
  input: z.object({ countryCode: z.string(), stateCode: z.string() }),
  output: z.array(citySchema),
};
